export const ALL_BLOCKS = "ALL";
export type BlockId = typeof ALL_BLOCKS | number;
